import { render, staticRenderFns } from "./draggable-topic-bar.vue?vue&type=template&id=6dd69f2e&scoped=true&lang=html&"
import script from "./draggable-topic-bar.vue?vue&type=script&lang=js&"
export * from "./draggable-topic-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd69f2e",
  null
  
)

export default component.exports